<template>
  <div class="ds-overlay" @click.self="closeModal">
    <div
      class="ds-card"
      role="dialog"
      aria-modal="true"
      aria-labelledby="defaultSetupTitle"
    >
      <!-- Header -->
      <header class="ds-header">
        <div class="ds-header__heading">
          <span class="ds-header__badge"><i class="fa fa-sliders"></i></span>
          <h4 class="ds-header__title" id="defaultSetupTitle">
            {{ $t("navigations.default preferences") }}
          </h4>
        </div>
        <button
          type="button"
          class="ds-close p-0"
          :aria-label="$t('navigations.close')"
          :title="$t('navigations.close')"
          @click.prevent="closeModal"
        >
          <i class="fa fa-times"></i>
        </button>
      </header>

      <!-- Body -->
      <div class="ds-body">
        <div class="ds-grid">
          <!-- Select Role -->
          <div class="ds-field">
            <label class="ds-field__label">
              <i class="fa fa-id-badge ds-field__icon"></i>
              {{ $t("navigations.default role") }}
            </label>
            <div class="ds-field__control">
              <select v-model="selectedRole" class="ds-select">
                <option value="" selected>
                  {{ $t("navigations.select a role") }}
                </option>
                <option
                  v-for="role in roleList"
                  :key="role.roleID"
                  :value="role.roleID"
                >
                  {{ role.roleName }}
                </option>
              </select>
              <button
                type="button"
                class="ds-save"
                :title="$t('navigations.save')"
                :aria-label="$t('navigations.save')"
                @click="updateDefaultRole()"
              >
                <i class="fa fa-check"></i>
              </button>
            </div>
          </div>

          <!-- Default study configuration -->
          <div class="ds-field">
            <label class="ds-field__label">
              <i class="fa fa-flask ds-field__icon"></i>
              {{ $t("navigations.default study") }}
            </label>
            <div class="ds-field__control">
              <select v-model="currentStudy" class="ds-select">
                <option value="" selected>
                  {{ $t("navigations.select a study") }}
                </option>
                <option
                  v-for="study in studyList"
                  :key="study.studyId"
                  :value="study.studyId"
                >
                  {{ study.studyRef }}
                </option>
              </select>
              <button
                type="button"
                class="ds-save"
                :title="$t('navigations.save')"
                :aria-label="$t('navigations.save')"
                @click="UpdateClicked()"
              >
                <i class="fa fa-check"></i>
              </button>
            </div>
          </div>

          <!-- Date format -->
          <div class="ds-field">
            <label class="ds-field__label">
              <i class="fa fa-calendar ds-field__icon"></i>
              {{ $t("navigations.date format") }}
            </label>
            <div class="ds-field__control">
              <select class="ds-select" v-model="defaultdateFormat">
                <option value="" selected>
                  {{ $t("navigations.select date format") }}
                </option>
                <option
                  v-for="date in dateList"
                  :key="date.dateFormat"
                  :value="date.dateFormat"
                >
                  {{ date.dateFormat }}
                </option>
              </select>
              <button
                type="button"
                class="ds-save"
                :title="$t('navigations.save')"
                :aria-label="$t('navigations.save')"
                @click="updateDefDateFormat()"
              >
                <i class="fa fa-check"></i>
              </button>
            </div>
          </div>

          <!-- Time format -->
          <div class="ds-field">
            <label class="ds-field__label">
              <i class="fa fa-clock-o ds-field__icon"></i>
              {{ $t("navigations.time format") }}
            </label>
            <div class="ds-field__control">
              <select class="ds-select" v-model="defaultTimeFormat">
                <option value="" selected>
                  {{ $t("navigations.select time format") }}
                </option>
                <option value="h:mm A">{{ $t("navigations.12 hrs") }}</option>
                <option value="HH:mm">{{ $t("navigations.24 hrs") }}</option>
              </select>
              <button
                type="button"
                class="ds-save"
                :title="$t('navigations.save')"
                :aria-label="$t('navigations.save')"
                @click="updateTimeFormat()"
              >
                <i class="fa fa-check"></i>
              </button>
            </div>
          </div>

          <!-- Graph type -->
          <div class="ds-field">
            <label class="ds-field__label">
              <i class="fa fa-sitemap ds-field__icon"></i>
              {{ $t("navigations.graph type") }}
            </label>
            <div class="ds-field__control">
              <select class="ds-select" v-model="defaultGraphType">
                <option value="" selected>
                  {{ $t("navigations.select graph type") }}
                </option>
                <option value="dagre">Dagre</option>
                <option value="breadthfirst">Breadthfirst</option>
                <option value="grid">Grid</option>
                <option value="cose">Cose</option>
              </select>
              <button
                type="button"
                class="ds-save"
                :title="$t('navigations.save')"
                :aria-label="$t('navigations.save')"
                @click="updateGraphType()"
              >
                <i class="fa fa-check"></i>
              </button>
            </div>
          </div>

          <!-- Local language -->
          <div class="ds-field">
            <label class="ds-field__label">
              <i class="fa fa-globe ds-field__icon"></i>
              {{ $t("navigations.preferred language") }}
            </label>
            <div class="ds-field__control">
              <select v-model="defaultlanguage" class="ds-select">
                <option value="" selected>
                  {{ $t("navigations.select a language") }}
                </option>
                <option
                  v-for="lang in langList"
                  :key="lang.code"
                  :value="lang.code"
                >
                  {{ lang.language }}
                </option>
              </select>
              <button
                type="button"
                class="ds-save"
                :title="$t('navigations.save')"
                :aria-label="$t('navigations.save')"
                @click="updateDefLanguage(defaultlanguage)"
              >
                <i class="fa fa-check"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="./DefaultSetupPopUp.js"></script>
<style scoped>
.ds-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  background: rgba(17, 24, 39, 0.45);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: 3000;
  animation: ds-fade 0.2s ease-out;
}

.ds-card {
  width: 100%;
  max-width: 560px;
  max-height: 90vh;
  overflow-y: auto;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 20px 48px -12px rgba(20, 95, 175, 0.28),
    0 4px 12px rgba(0, 0, 0, 0.08);
  animation: ds-pop 0.24s cubic-bezier(0.16, 1, 0.3, 1);
}

/* Header */
.ds-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1.25rem;
  border-bottom: 1px solid #eef1f6;
  position: sticky;
  top: 0;
  background: #fff;
  border-radius: 16px 16px 0 0;
  z-index: 1;
}

.ds-header__heading {
  display: flex;
  align-items: center;
  gap: 0.7rem;
}

.ds-header__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: linear-gradient(135deg, #1a73e8, #3f98ff);
  color: #fff;
  font-size: 1rem;
  flex-shrink: 0;
}

.ds-header__title {
  margin: 0;
  font-size: 1.0rem;
  font-weight: 600;
  color: #494949;
}

.ds-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: #f3f4f6;
  color: #6b7280;
  cursor: pointer;
  transition: background 0.18s ease, color 0.18s ease, transform 0.18s ease;
}

.ds-close:hover {
  background: #fde2e2;
  color: #dc2626;
  transform: rotate(90deg);
}

/* Body */
.ds-body {
  padding: 1.1rem 1.25rem 1.35rem;
}

.ds-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.85rem;
}

.ds-field {
  background: #f8fafc;
  border: 1px solid #eef1f6;
  border-radius: 12px;
  padding: 0.7rem 0.8rem;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.ds-field:hover {
  border-color: #cddcf1;
  box-shadow: 0 2px 8px rgba(20, 95, 175, 0.06);
}

.ds-field__label {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0 0 0.45rem 0;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: #64748b;
}

.ds-field__icon {
  color: #145faf;
  font-size: 0.8rem;
}

.ds-field__control {
  display: flex;
  align-items: stretch;
  gap: 0.4rem;
}

.ds-select {
  flex: 1 1 auto;
  min-width: 0;
  height: 32px;
  padding: 0 0.6rem;
  font-size: 0.72rem;
  color: #494949;
  background-color: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  outline: none;
  cursor: pointer;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.ds-select:focus {
  border-color: #145faf;
  box-shadow: 0 0 0 3px rgba(20, 95, 175, 0.15);
}

.ds-save {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 9px;
  background: linear-gradient(135deg, #145faf, #2f7ad1);
  color: #fff;
  font-size: 0.85rem;
  cursor: pointer;
  transition: filter 0.18s ease, transform 0.12s ease, box-shadow 0.18s ease;
  box-shadow: 0 2px 6px rgba(20, 95, 175, 0.25);
}

.ds-save:hover {
  filter: brightness(1.08);
  box-shadow: 0 4px 10px rgba(20, 95, 175, 0.32);
}

.ds-save:active {
  transform: scale(0.94);
}

@keyframes ds-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes ds-pop {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (max-width: 575px) {
  .ds-grid {
    grid-template-columns: 1fr;
  }
  .ds-card {
    max-width: 100%;
  }
}
</style>
